module.exports = __webpack_public_path__ + "static/media/nachoPhoto.c6f93e96.png";